import { render } from "./Dragons.vue?vue&type=template&id=0961a4f1"
import script from "./Dragons.vue?vue&type=script&lang=js"
export * from "./Dragons.vue?vue&type=script&lang=js"
script.render = render

export default script